import { useState } from "react";
import { CreditLinkagePostAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/BeneficiaryDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";


const AddCreditLinkagePopup = (props) => {

    const { handleAddCreditLinkage, Title,M_BeneficiaryDetailsID,handleIsCreditLinkageData } = props

    
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const [CreditLinkage, setCreditLinkage] = useState([])

    const handleValueChange = (newValue) => {
        if (CreditLinkage?.includes(newValue)) {
            setCreditLinkage(CreditLinkage.filter(value => value != newValue));
        } else {
            setCreditLinkage([...CreditLinkage, newValue]);
        }
    };

    // console.log("CreditLinkage",CreditLinkage)
    
    

    const handleSubmit = () => {
        const data = {
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            CreditLinkage: CreditLinkage,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsCreditLinkageData

        }
        dispatch(CreditLinkagePostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.CreditLinkagePostData)

    return (<>
        <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
            <div className="modal-dialog modal-lg" role="document"  >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ml-lg-5" id="exampleModalLongTitle">{Title}</h5>
                        <button onClick={handleAddCreditLinkage} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body mx-4">
                        <div className="row">

                            <div className="col-12">
                                <span className="fw-bold">
                                    Select Credit Linkage:
                                </span>

                            </div>

                            <div className="col-12 col-lg-4 pt-3 mx-auto">
                                <form >
                                    <input type="checkbox"
                                        className="px-3"
                                        id="Polybag"
                                        name="Polybag"
                                        value="Polybag"
                                        onChange={() => handleValueChange('47')}
                                    />
                                    <label for="Polybag" className="ps-2">Input </label>
                                </form>

                            </div>


                            <div className="col-12 col-lg-4 pt-3">
                                <form >
                                    <input type="checkbox"
                                        className="px-3"
                                        id="Polybag"
                                        name="Polybag"
                                        value="Polybag"
                                        onChange={() => handleValueChange('48')}
                                    />
                                    <label for="Polybag" className="ps-2">Support for credit</label>
                                </form>


                            </div>

                            <div className="col-12 col-lg-4 pt-3">
                                <form >
                                    <input type="checkbox"
                                        className="px-3"
                                        id="Polybag"
                                        name="Polybag"
                                        value="Polybag"
                                        onChange={() => handleValueChange('49')}

                                    />
                                    <label for="Polybag" className="ps-2">Support in availing loan</label>
                                </form>


                            </div>

                            <div className="col-12  d-flex justify-content-center pt-5">
                                <div className="form-group w-80 d-flex justify-content-between">

                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className="btn btn-outline-dark border-2 mx-2" data-ktwizard-type="action-next">
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleAddCreditLinkage}
                                        className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>




                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default AddCreditLinkagePopup;